import { darken, lighten } from 'polished';

const brand = {
    primary: '#242424',
    secondary: '#FFE900'
};

const colors = {
    primary: brand.primary,
    primary_hover: lighten(0.075, brand.primary),
    secondary: brand.secondary,
    secondary_hover: lighten(0.075, brand.secondary),
    yellow: brand.secondary,
    lightYellow: '#FEEBC9',
    blue: brand.primary,
    darkBlue: '#2D286F',
    black: '#000',
    cyan: '#E6F3F5',
    darkCyan: '#D6E4E8',
    darkerCyan: darken(0.025, '#D6E4E8'),
    white: '#FFF',
    mint: '#4FAD76',
    light: '#F4F4F4',
    medium: '#D6E4E8',
    border: '#DDDDDD',
    dark: '#242424',
    red: '#EB3636',
    lightRed: '#FBC9C9',
    green: '#288435',
    lightGreen: '#CFF6DF',
    placeholder: '#899293',
    grey: '#6c757d',
    lightGrey: '#F2F2F2',
    footer: '#535353',
    text: '#535353'
};

const fontSizes = {
    normal: 16,
    h1: '2.625rem',
    h2: 33,
    h3: 24,
    h4: 19,
    bigger: 18,
    smaller: 14,
    tiny: 13
};

const borderRadius = {
    normal: 8,
    small: 4
};

const theme = {
    colors,
    fontSizes,
    borderRadius,
    constants: {
        borderRadius: 14,
        bar: 85,
        spacer: 24,
        panelPadding: 32,
        menuWidth: 336,
        menuLeft: 50,
        menuTop: '7.5rem',
        titleHeaderHeight: '6rem',
        topBarContentHeight: 40,
        footerHeight: '5rem',
        iframeHeight: 500,
        shadow: `3px 3px 14px ${colors.darkCyan}`,
        containerPaddingHorizontal: 50,
    },
    formElements: {
        label: {
            fontSize: 13,
            fontWeight: 600,
            color: colors.darkBlue,
        },
        backgroundColor: colors.light,
        border: `1px solid ${colors.darkCyan}`,
        shadow: `3px 3px 14px ${colors.darkCyan}`,
        borderRadius: 10,
        padding: 14,
        paddingSelect: 4,
        paddingHorizontal: 14,
        color: colors.black
    },
    breakpoints: [400, 600, 900, 1300, 1550]
};
export default theme;
